import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { Alert, AlertTitle } from '@material-ui/lab';
import { Grid } from '@material-ui/core';
import { HashLink as Link } from 'react-router-hash-link';

import { selectLanguage } from '../../redux/language/language.selectors';

import EN_DATA from '../../data/language/english.data';
import PT_DATA from '../../data/language/portuguese.data';

import './Congratulations.scss';

function Congratulations({ language }) {
  // getting language text
  const text = language === 'EN' ? EN_DATA.sections.congratulations : PT_DATA.sections.congratulations;

  return (
    <div className="container congratulations">
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Alert severity="success" center={'true'}>
            <AlertTitle>{text[0]}</AlertTitle>{text[1]}
          </Alert>
        </Grid>
        <Grid item xs={12}>
          <Link
            className="btn-purple"
            to="/dashboard"
          >
            {text[2]}
          </Link>
        </Grid>
      </Grid>
    </div>
  );
}

const mapStateToProps = createStructuredSelector({
  language: selectLanguage
});

export default connect(mapStateToProps, null)(Congratulations);